export const GET_ACTIVITY_LOGS = gql`
  query GetActivityLogs(
    $applicantId: String!
    $filters: ActivityLogFiltersInput
    $pageInfo: PageInfoInput
  ) {
    activityLogs(
      applicantId: $applicantId
      filters: $filters
      pageInfo: $pageInfo
    ) {
      totalCount
      items {
        activityLogId
        createdAt
        recordingSid
        recordingUrl
        updatedAt
        activityDate
        connectedStatus
        voeFindings
        callType
        task {
          taskId
          title
          status
          dueDate
        }
        documents {
          documentId
          createdAt
          updatedAt
          status
          userStatus
          uploadStatus
          fileType
          fileName
          uploadUrl
          documentIntelligence {
            status
            predictions {
              field
              confidence
              autoApplied
              reviewDecision
            }
          }
        }
        type
        title
        content
        actorType
        smsDirection
        callDirection
        callStatus
        startCallDate
        endCallDate
        callDuration
        transcriptFileUrl
        transcriptSummary
        labels
        voeId
        voe {
          voeId
          companyName
        }
        employee {
          employeeId
          firstName
          lastName
        }
        voiceMailTemplate {
          voiceMailTemplateId
          title
        }
        voiceAgent {
          voiceAgentId
          name
        }
        emailId
        email {
          emailThreadId
          snippet
          direction
          date
        }
        taskId
      }
    }
  }
`

export const FIND_ACTIVITY_LOG_COMPANY_FOR_SWITCH = gql`
  query FindActivityLogCompanyForSwitch($activityLogId: String!) {
    findActivityLogCompanyForSwitch(activityLogId: $activityLogId) {
      activityLogId
      applicantName
      companyId
      companyName
      employeeId
    }
  }
`

export const GET_ACTIVITY_LOG = gql`
  query GetActivityLog($id: String!) {
    activityLog(id: $id) {
      activityLogId
      createdAt
      recordingSid
      recordingUrl
      updatedAt
      activityDate
      connectedStatus
      voeFindings
      callType
      from
      to
      documents {
        documentId
        createdAt
        updatedAt
        status
        userStatus
        uploadStatus
        fileType
        fileName
        uploadUrl
      }
      type
      title
      content
      actorType
      smsDirection
      callDirection
      callStatus
      startCallDate
      endCallDate
      callDuration
      transcriptFileUrl
      transcriptSummary
      blandCallSid
      discussionTopics
      labels
      applicant {
        applicantId
        firstName
        middleName
        lastName
      }
      employee {
        employeeId
        firstName
        lastName
      }
      voiceMailTemplate {
        voiceMailTemplateId
        title
      }
      voiceAgentAnalysisResults {
        voiceAgentAnalysisResultId
        createdAt
        updatedAt
        name
        result
      }
      machineDetectionResult
      voeId
      voe {
        voeId
        companyName
      }
      voiceAgent {
        voiceAgentId
        name
      }
      bookings {
        bookingId
        employee {
          employeeId
          firstName
          lastName
        }
      }
      emailId
      email {
        emailThreadId
        snippet
        direction
        date
      }
    }
  }
`

export const GET_CALLS = gql`
  query GetCalls($filters: CallFiltersInput, $pageInfo: PageInfoInput) {
    getCalls(filters: $filters, pageInfo: $pageInfo) {
      totalCount
      items {
        activityLogId
        createdAt
        recordingSid
        recordingUrl
        updatedAt
        activityDate
        callType
        from
        to
        documents {
          documentId
          createdAt
          updatedAt
          status
          userStatus
          uploadStatus
          fileType
          fileName
          uploadUrl
        }
        type
        title
        content
        smsDirection
        callDirection
        callStatus
        connectedStatus
        voeFindings
        startCallDate
        endCallDate
        callDuration
        transcriptFileUrl
        transcriptSummary
        labels
        voiceAgent {
          voiceAgentId
          name
        }
        voeId
        voe {
          voeId
          companyName
        }
        voiceAgentAnalysisResults {
          voiceAgentAnalysisResultId
          createdAt
          updatedAt
          name
          result
        }
        applicant {
          applicantId
          firstName
          middleName
          lastName
        }
        employee {
          employeeId
          firstName
          lastName
        }
        voiceMailTemplate {
          voiceMailTemplateId
          title
        }
      }
    }
  }
`

export const GET_ACTIVE_CALL = gql`
  query GetActiveCall {
    getActiveCall {
      activityLogId
      createdAt
      updatedAt
      activityDate
      type
      title
      content
      smsDirection
      callDirection
      callStatus
      employee {
        employeeId
        firstName
        lastName
      }
    }
  }
`

export const COMPLETE_ACTIVE_CALL = gql`
  mutation CompleteActiveCall {
    completeActiveCall {
      activityLogs {
        activityLogId
      }
    }
  }
`

export const TRANSFER_CALL_TO_EMPLOYEE = gql`
  mutation TransferCallToEmployee($input: TransferCallToEmployeeInput!) {
    transferCallToEmployee(input: $input) {
      success
      message
    }
  }
`

export const DOWNLOAD_RECORDING_URL = gql`
  query GetRecordingDownloadUrl($activityLogId: String!) {
    getRecordingDownloadUrl(activityLogId: $activityLogId) {
      url
      fileName
    }
  }
`

export const CREATE_ACTIVITY_LOG = gql`
  mutation CreateActivityLog($input: CreateActivityLogInput!) {
    createActivityLog(input: $input) {
      activityLogId
      task {
        taskId
      }
    }
  }
`

export const UPDATE_ACTIVITY_LOG = gql`
  mutation UpdateActivityLog($id: String!, $input: UpdateActivityLogInput!) {
    updateActivityLog(id: $id, input: $input) {
      activityLogId
      content
      updatedAt
    }
  }
`

export const DELETE_ACTIVITY_LOG = gql`
  mutation DeleteActivityLog($id: String!) {
    deleteActivityLog(id: $id) {
      activityLogId
    }
  }
`

export const BULK_SMS = gql`
  mutation BulkSms(
    $applicants: [String!]!
    $textTemplateId: String
    $content: String
  ) {
    bulkSms(
      applicants: $applicants
      textTemplateId: $textTemplateId
      content: $content
    ) {
      applicants {
        applicantId
        success
        errorMsg
      }
    }
  }
`

export const BULK_CALL = gql`
  mutation BulkCall($applicants: [String!]!, $activityDate: DateTime!) {
    bulkCall(applicants: $applicants, activityDate: $activityDate) {
      applicants {
        applicantId
        success
        errorMsg
      }
    }
  }
`

export const DOWNLOAD_TRANSCRIPT_URL = gql`
  query GetTranscriptDownloadUrl($activityLogId: String!) {
    getTranscriptDownloadUrl(activityLogId: $activityLogId) {
      url
      fileName
    }
  }
`

export const DOWNLOAD_CALL_CSV = gql`
  mutation DownloadCallCsv($filters: CallFiltersInput) {
    downloadCallCSV(filters: $filters) {
      fileContent
      fileName
    }
  }
`
